import React from 'react';
import { Image } from 'react-bootstrap';

import './Language.css';

const language = props => (
  <div className="column-container lang">

    <a href="#english">English</a>
    <a href="#deutsch">Deutsch</a>
    <a href="#norsk">Norsk</a>
    <a href="#svenska">Svenska</a>

    <div className="line" id="english"/>

    <div className="language-info">
      <Image src="images/Flaggor/englands_flagga.jpg" />

      <h3>Be a good and decent friend – the important message in the book and music story about the ”Friends in King’s Forest</h3>

      <p>”Friends in King’s Forest” is an entertaining and funny story for childen about two companions who finally become six friends, with a concept of ethics, friendship and co-operation. The pictures, story, dialogue songs and toys will give children valuable lessons how to be good friends in a playful form.</p>

      <p><b>We are looking for agents and publishers who want to publish ”Friends in King’s Forest” in other countries.</b></p>

      <h4>FACTS ABOUT THE SUCCESS</h4>
      <p>Two different materials are available:</p>
      <p>• The friends in King’s Forest build a hut (48 pages, 12 songs, 2 hours of dialogs on CD och App)</p>
      <p>• The friends in King’s Forest go on an excursion in the forest (80 pages, 19 songs, 3 hours of dialogs on CD och App)</p>
      <p>• The friends in King’s Forest has made great success in Sweden and 70% of all preschools in Sweden use the material!</p>
      <p>All children in different contries can easily understand the story. Age: 3-8 years.</p>
      <p>• About the songs: The music is international and the style can be used in many countries. The lyrics are about being a good friend.</p>
      <p>• YouTube: Use keyword "Kungaskogen" and find our films.</p>
      <p>• The friends in King’s forest also makes success as a film showcase throughout Sweden. Last year the theatre was shown for 20,000 children in 47 places in Sweden.</p>

      <h4>The friends in King’s forest</h4>
      <p>Do your own production. Sign a license. Easy to do an own production. We help you with translation, artists and production. Songs and dialogs can be played from CD or App.</p>
      <p>ILKA and Wasa Music has production technology for YouTube productions and Audio recordings.</p>
      <p>The friends of King’s Forest have been developed from a team of over 30 people consisting of authors, illustrators, original actors, actors, musicians, composers and music producers. All assets in the children’s market.</p>

      <p>”It swings”, says Wilma, six years old. ”You become kinder”, children say. ”Fantastic”, say adults. ”Children begin to talk about how it feels not to be left out.”</p>

      <p><b>Lisa Grane, Author</b>: “Childhood is the most important a child has. I want every child in the world learn to have respect for each other and stay good friends for a better world. That’s why I’m telling the story about the friends in the King’s forest”.</p>

      <h4>Licensing</h4>
      <p>ILKA Förlagsprodutker AB Sweden and Wasa Music AB. Wasa Music is a hole members of Stim Sweden (STIM is a Swedish collective management organization for music creators and publishers) and member of SKAP – The Swedish Society of Songwriters, Composers & Authors. All rights reserved.</p>

      <p>Many Scandinavian story books for children are famous all over the world. Astrid Lindgren ”Pippi Longstocking”, Tove Janson ”Moomin”, Thorbjörn Egner ”When the Robbers Came to Cardamom Town”.</p>
      <p>The story of ”Friends from King’s Forest” is one of the most popular stories for children in Kindergarten in the new millennium.</p>

      <p>Please listen to <a href="https://soundcloud.com/wasamusic/the-friends-song" target="_blank" rel="noopener noreferrer">The Friends Song</a> from the story.</p>

      <a href="https://www.youtube.com/watch?v=LfrfYrt8C2c" target="_blank" rel="noopener noreferrer">The swedish King Carl Gustav listen to some songs from The friends in King’s forest</a>

      <p>Theatre Vännerna i Kungaskogen</p>
      <a href="https://www.youtube.com/watch?v=5HDUwImaUkU&t=13s" target="_blank" rel="noopener noreferrer">Trailer</a>
      <br/>
      <a href="https://www.google.se/search?q=kungaskogen&source=lnms&tbm=isch&sa=X&ved=0ahUKEwjA-I6O3M_fAhUFCywKHQ_nBt0Q_AUIDigB&biw=878&bih=440" target="_blank" rel="noopener noreferrer">Google in Sweden Kungaskogen</a>

      <h4>Spotify</h4>
      <p>Use key Word <b>kungaskogen</b> or  <b>königswald</b> or <b>kongeskogen</b></p>

      <p>Welcome with you reguest!</p>

      <p>Kind regards</p>
      <p>ILKA</p>

      <p>+46/40/120012</p>
      <p>idea@ilka.se</p>
    </div>

    <div className="line" id="deutsch"/>

    <div className="language-info">
      <Image src="images/Flaggor/tysklands_flagga.jpg" />

      <h3>Sei ein guter und anständiger Freund - die wichtige Botschaft in der Buch- und Musikgeschichte über die "Freunde im Königswald".</h3>

      <p>Die Freunde im Königswald ist eine unterhaltsame und lustige Geschichte für Kinder über zwei Freunde, die schließlich sechs Freunde werden, mit einem Konzept von Ethik, Freundschaft und Zusammenarbeit. Die Bilder, Geschichten, Dialog, Lieder und Spielsachen geben Kindern wertvolle Lektionen, wie man auf spielerische Weise gute Freunde sein kann.</p>

      <h4>FAKTEN ÜBER DEN ERFOLG</h4>
      <p>Es stehen zwei verschiedene Materialien zur Verfügung:</p>
      <p>• Die Freunde in King's Forest bauen eine Hütte (48 Seiten, 12 Songs, 2 Stunden Dialoge auf CD und App)</p>
      <p>• Die Freunde in King's Forest machen einen Ausflug in den Wald (80 Seiten, 19 Lieder, 3 Stunden Dialoge auf CD und App)</p>
      <p>• Die Freunde in King's Forest waren in Schweden sehr erfolgreich und 70% aller Vorschulen in Schweden verwenden das Material!</p>
      <p>Alle Kinder in verschiedenen Ländern können die Geschichte leicht verstehen. Alter: 3-8 Jahre</p>
      <p>• Zu den Songs: Die Musik ist international und der Stil kann in vielen Ländern verwendet werden. In den Texten geht es darum, ein guter Freund zu sein.</p>
      <p>• Die Freunde in King's Forest machen auch als Filmschaukasten in ganz Schweden Erfolg. Letztes Jahr wurde das Theater für 20.000 Kinder an 47 Orten in Schweden gezeigt.</p>

      <p><b>Lisa Grane, Autorin</b>: Kindheit ist das Wichtigste, was ein Kind hat. Ich möchte, dass jedes Kind der Welt lernt, einander zu achten und gute Freunde für eine bessere Welt zu sein. Deshalb erzähle ich die Geschichte der Freunde des Königswaldes.</p>

      <a href="https://soundcloud.com/wasamusic/konigswald-trailer" target="_blank" rel="noopener noreferrer">Königswald Präsentation Hörtrailer</a>
      <br/>

      <a href="https://vimeo.com/manage/videos/420658311" target="_blank" rel="noopener noreferrer">Präsentation der Freunde im Königswald. Video</a>


      <p>Der schwedische König und Königin Silvia hören Lieder aus dem Königswald</p>
      <a href="https://www.youtube.com/watch?v=LfrfYrt8C2c" target="_blank" rel="noopener noreferrer">Königin Siliva. Lieder aus dem Königswald. YouTube</a>



      <h4>Spotify</h4>
      <p>Use key Word <b>königswald</b></p>

      <a href="https://www.google.se/search?q=kungaskogen&source=lnms&tbm=isch&sa=X&ved=0ahUKEwjA-I6O3M_fAhUFCywKHQ_nBt0Q_AUIDigB&biw=878&bih=440" target="_blank" rel="noopener noreferrer">Google in Sweden Kungaskogen</a>
    </div>

    <div className="line" id="norsk"/>

    <div className="language-info">
      <Image src="images/Flaggor/norges_flagga.jpg" />

      <h3>Suksess for barnebøker om vennskap, moral, etikk, samarbeid og miljø.</h3>

      <h4>Snick & Snack Vennene i Kongeskogen</h4>

      <p>Historien "Vennene i Kongeskogen" handler om dyr i en skog som bygger en hytte. Viktig i historien er å være en fin og god venn, respekt for andre, empati, mot utestengin og mobbing. På TV stemmer du hverandre ut. I "Vennene i Kongeskogen" må alle være med. Barnene kan enkelt forholde seg til sine egne erfaringer gjennom de sterke dyrkarakterene som blir deres rollemodeller. Materialet har gjort stor suksess i Sverige, og nå er utgiveren klar til å jobbe for en utenlandsk lansering.
        Prøveoversettelser med provinsspill har blitt gjort, for eksempel på norsk, engelsk og tysk.</p>

      <div className="compact">
        <p>"Vennene i Kongeskogen" består av 2 bøker med bildehistorier, sanger med notater, 6 CD:er (musikk og dialoger er også tilgjengelige på App). For skoler finns det ca. 800 sider med arbeidsmateriale, Access Kongeskogen, som lastes ned fra Internett.</p>
        <p>Alder: 3 - 7 år</p>
      </div>

      <div className="compact">
        <p>Merchandise er utviklet som puslespill, spill, klistremerker, T-shirt, hånddukker, apps, perler, YouTube-klipp, teater etc.</p>
        <p>CDene (Apparna) inneholder fortellere, dialoger og musikk. Notater for musikken er i bøkene.</p>
      </div>

      <p>Handling: Ekornet Snick og pinnsvin Snack vil bygge en hytte. 2 venner vil være 3 venner, 4 venner, etc. Hver gang noen får lov til å leke og spille, skjer en dramatisk hendelse hvor alle dyrene kommer til det punktet at det er bedre å være venner og samarbeide enn å ikke leke sammen. Hytten er klar og 6 venner og elgen, skogens konge, feirer med en fest. I neste historie går vennene på en ekskursjon i skogen og møter nye venner. En av de nye vennene, frosken Gronilla driver en
        organiskt kafé og lærer hvordan man tar vare på klima og miljø.</p>

      <p>Flertallet av barn i svenske barnehager arbeider med "Venne i Kongeskogen". Lærerne arbeider tematisk med historien og temaene dekker de fleste ting i læreplanen. Man leser sammen deler fra historien, dramatiserer og snakker. Du hører på CD:ene flittig, synger sangene og gjør mange aktiviteter om innholdet i historien og basert på arbeidsmaterialet. Et teater er også tilgjengelig om "Venne i Kongeskogen", som for tiden reiser rundt i Sverige for utsolgte hus.</p>

      <p><b>Lisa Grane, Forfatter</b>: Barndommen er det viktigste barnet har. Jeg vil at hvert barn i verden skal lære å respektere hverandre og være gode venner for en bedre verden. Derfor forteller jeg historien om Vennene i Kongeskogen.</p>

      <p>Lisenser: Förlagshuset Wasa/ILKA Förlagsprodukter AB, Sverige</p>

      <p>Velkommen til Kongeskogen!</p>

      <div className="compact">
        <p>Vennlig hilsen</p>
        <p>Förlagshuset Wasa/ILKA</p>
      </div>

      <p>+46/40/120012 idea@ilka.se</p>

      <br/>
      <a href="https://soundcloud.com/wasamusic/kongeskogen-trailer" target="_blank" rel="noopener noreferrer">Kongeskogen Presentasjon Trailer. Lytte.</a>
      <br/>

      <a href="https://vimeo.com/manage/videos/419843335" target="_blank" rel="noopener noreferrer">Kongeskogen presentasjion. Video</a>
      <br/>
      <a href="https://www.youtube.com/watch?v=2RoEMV5Zwuk" target="_blank" rel="noopener noreferrer">Raffe Räv Vrikke Vrikke. YouTube</a>
      <br/>
      <a href="https://www.youtube.com/watch?v=LfrfYrt8C2c" target="_blank" rel="noopener noreferrer">Svensk Kong Carl Gustav i Kongeskogen. YouTube</a>

      <h4>Spotify</h4>
      <p>Bruk søkeord <b>kongeskogen</b></p>


      <a href="https://www.google.se/search?q=kungaskogen&source=lnms&tbm=isch&sa=X&ved=0ahUKEwjA-I6O3M_fAhUFCywKHQ_nBt0Q_AUIDigB&biw=878&bih=440" target="_blank" rel="noopener noreferrer">Google i Sverige Kungaskogen</a>
      <br/>
      <a href="https://www.youtube.com/watch?v=CqnpETBQ4kY" target="_blank" rel="noopener noreferrer">Presentasjon Kongeskogen svensk YouTube</a>

    </div>

    <div className="line" id="svenska"/>

    <div className="language-info">
      <Image src="images/Flaggor/sveriges_flagga.jpg" />

      <h3>SUCCÉ I FÖR BARNBOKSSERIE om VÄNSKAP, MORAL, ETIK, SAMARBETE OCH MILJÖ.</h3>

      <h4>Nu söker förlaget utländska samarbetspartners!</h4>

      <p>Titel: Snick & Snack Vännerna i Kungaskogen</p>

      <p>Berättelsen ”Vännerna i Kungaskogen” handlar om djur i en skog som bygger en koja. Viktigt i berättelsen är att vara en schysst och bra kompis, respekt för andra, empati, mot utanförskap och mobbning. I TV röstar man ut varandra. I ”Vännerna i Kungaskogen” får alla vara med. Barnen kan lätt relatera till sina egna erfarenheter genom de starka djurkaraktärerna som blir förebilder. Materialet har gjort stor succé i Sverige och nu är förlaget redo att arbeta för en utlandslansering.
        Provöversättningar med provinspelningar har gjorts bl a till norska, engelska och tyska.</p>

      <div className="compact">
        <p>”Vännerna i Kungaskogen” består av 2 st böcker med bildberättelser, sånger med noter, 6 st CD skivor (musik och dialoger finns också på App). För skolor finns ca 800 sidors arbetsmaterial, Access Kungaskogen, som laddas ned från Internet.</p>
        <p>Ålder: 3 – 7 år</p>
      </div>

      <div className="compact">
      <p>Kringprodukter har utvecklats så som pussel, spel, klistermärken, T shirts, handdockor, appar, pärlor med pärlplattor, YouTube klipp, teater, mm</p>
      <p>CD-skivorna (Apparna) innehåller berättare, dialoger och musik. Noter till musiken finns i böckerna.</p>
      </div>

      <p>Handling: Ekorren Snick och igelkotten Snack ska bygga en koja. 2 kompisar blir 3 kompisar, 4 kompisar, osv. Varje gång någon ska komma med i gruppen så utspelas en dramatisk händelse där inblandande kommer på att det är bättre att vara kompisar och samarbeta än att inte leka tillsammans. Kojan blir klar och 6 nya vänner och älgen, skogens konung, firar med ett stort kalas.</p>
      <p>Den nya kompisgruppen som byggt koja tillsammans går sen på utflykt i Kungaskogen för att upptäcka saker i naturen och träffar fler kompisar. De träffar nya kompisen grodan Gronilla som har uppfunnit ett kretsloppscafé i Kungaskogen. Grodan Gronilla visar också hur hon har hittat på ett sätt att ta hand om miljön och sopor.</p>

      <p>En majoritet av barn i svensk förskola jobbar med "Vännerna i Kungaskogen". Pedagogerna arbetar tematiskt med sagan och teman täcker det mesta i läroplanen. Man läser tillsammans avsnitt ur berättelsen, dramatiserar och samtalar. Man lyssnar flitigt på CD skivorna, sjunger sångerna och gör en mängd aktiviteter kring sagans innehåll och utifrån arbetsmaterialet. En teater finns också om "Vännerna i Kungaskogen" som just nu turnerar i hela Sverige för utsålda hus.</p>

      <p>"Det svänger", säger Wilma, sex år gammal. "Du blir snällare", säger barnen. "Fantastiskt", säger vuxna. "Barn börjar prata om hur det känns att bli utelämnad."</p>

      <p><b>Lisa Grane, Författare</b>: Barndom är det viktigaste som ett barn har. Jag vill att alla barn i världen lär sig att ha respekt för varandra och vara goda vänner för en bättre värld. Därför berättar jag historien om Vännerna i Kungaskogen.</p>

      <p>Licenser: ILKA Förlagsprodukter AB, Sweden</p>

      <div className="compact">
        <p>Välkommen till Kungaskogen.</p>
        <p>Med vänlig hälsning</p>
        <p>Förlagshuset Wasa/ILKA</p>
      </div>

      <p>+46/40/120012 idea@ilka.se</p>

      <a href="https://soundcloud.com/wasamusic/kungaskogen-kojan-trailer" target="_blank" rel="noopener noreferrer">Kojan Trailer</a>
      <br/>
      <a href="https://soundcloud.com/wasamusic/kungaskogen-utflykt-trailer" target="_blank" rel="noopener noreferrer">Utflykt Trailer</a>
      <br/>
      <a href="https://soundcloud.com/wasamusic/kungaskogen-snick-slinga-utflykt" target="_blank" rel="noopener noreferrer">Snick om Utflykt</a>
      <br/>
      <a href="https://www.youtube.com/watch?v=09ERI0nDwY0" target="_blank" rel="noopener noreferrer">Raffe Räv Vicka Vicka</a>
      <br/>
      <a href="https://www.youtube.com/watch?v=5HDUwImaUkU&t=13s" target="_blank" rel="noopener noreferrer">Vännerna i Kungaskogen Bioteater. Trailer</a>
      <br/>
      <a href="https://www.youtube.com/watch?v=LfrfYrt8C2c" target="_blank" rel="noopener noreferrer">Svenska Kungen Carl Gustav i Kungaskogen. YouTube</a>

    </div>
  </div>

);

export default language;
